import { Link, Outlet } from 'react-router-dom';

export type StaffUser = { id: string; name: string; email: string; role: string };

export function AdminLayout({ user, billingMode, onSignOut }: {
  user: StaffUser; billingMode?: string; onSignOut: () => void;
}) {
  return (
    <div className="simple-shell admin-shell">
      {billingMode === 'demo' && <div className="demo-banner">Demo mode: payments and emails are simulated.</div>}
      <header className="simple-topbar">
        <Link className="simple-brand" to="/admin/customers"><span>W</span><strong>WebForGrowth</strong></Link>
        <Link className="owner-nav" to="/admin/customers">Customers</Link>
        <div className="simple-account"><span>{user.name}</span><button className="secondary small" onClick={onSignOut}>Sign out</button></div>
      </header>
      <main className="simple-main"><Outlet /></main>
    </div>
  );
}
